'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.find')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.map')
require('core-js/modules/es.array.slice')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _Xhr = _interopRequireDefault(require('../Xhr'))
var _json = _interopRequireDefault(require('../json'))
var _arr = require('../arr')
var _obj = require('../obj')
var QueueRequests = /*#__PURE__*/ (function() {
  function QueueRequests(arg) {
    ;(0, _defineProperty2.default)(this, 'requests', [])
    ;(0, _defineProperty2.default)(this, 'api_url', void 0)
    ;(0, _defineProperty2.default)(this, 'token', void 0)
    ;(0, _defineProperty2.default)(this, 'queue', void 0)
    this.api_url = arg.api_url
    this.token = arg.token
    this.queue = arg.queue
  }
  var _proto = QueueRequests.prototype
  _proto.fetch = function fetch(arg) {
    var _this = this
    var onComplete = function onComplete(resp) {
      _this.onComplete(arg.ids.slice(0), resp)
    }
    var xhr = new _Xhr.default({
      url: this.api_url,
      body: {
        tasks: arg.ids
      },

      method: 'POST',
      onComplete: onComplete,
      headers: {
        'X-Access-Token': this.token
      }
    })

    this.requests.push(xhr)
  }
  _proto.stop = function stop() {
    this.requests.forEach(function(xhr) {
      xhr.destroy()
    })
    this.requests = []
  }
  _proto.onComplete = function onComplete(ids, resp) {
    var result = QueueRequests.prepareResult(ids, resp)
    this.queue._onRequestComplete(result)
  }
  QueueRequests.convertStatus = function convertStatus(str) {
    switch (str) {
      case 'SUCCESS':
        return 'done'
      case 'PENDING':
        return 'pending'
      case 'FAILURE':
        return 'failed'
      default:
        return 'failed'
    }
  }
  QueueRequests.prepareResult = function prepareResult(ids, resp) {
    var data = _json.default.parseObj(resp.response)

    if (resp.type === 'error' || data === null) {
      return {
        hasErr: true,
        ids: ids
      }
    }

    var tasks = (0, _arr.castArr)(data.tasks)
    var resultTasks = ids.map(function(id) {
      var tdata = tasks.find(function(td) {
        return td.id === id
      })
      if (!tdata) {
        return {
          id: id,
          status: 'notfound',
          data: {}
        }
      }

      return {
        id: id,
        status: QueueRequests.convertStatus(tdata.status),
        data: (0, _obj.castObj)(tdata.payload)
      }
    })

    return {
      hasErr: false,
      ids: ids,
      tasks: resultTasks
    }
  }
  _proto.destroy = function destroy() {
    this.stop()
    delete this.queue
  }
  return QueueRequests
})()
var _default = QueueRequests
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/TaskQueue/requests.js
// module id = 621
// module chunks = 0